import {config } from '../config/config';
import AuthService from './authServices';
import ApiService from './apiServices';
export const authService = new AuthService();
export const apiService  = new ApiService(config.apiUrl, authService);
export {default as cookies} from './cookies';
